import { determineBaseUrlAndPerformApiCall } from "../interceptor/interceptor";
import { USAGE_EVENT_TYPE_LISTING_API } from "../constants/constants";
import { fetchUsageEventTypeSuccess, fetchUsageEventTypeFailure } from "./reducer";

export const fetchAllUsageEventType = (setLoading) => async (dispatch) => {
    try {
        setLoading(true)
        const response = await determineBaseUrlAndPerformApiCall(`${USAGE_EVENT_TYPE_LISTING_API}`,'GET')
        setLoading(false)
        if (response.error && response.error.code === 'NotFound') {
            dispatch(fetchUsageEventTypeSuccess([]));
        }
        else {
            dispatch(fetchUsageEventTypeSuccess(response.reverse()))
        }
    }
    catch (error) {
        setLoading(false)
        dispatch(fetchUsageEventTypeFailure(error.message))
    }
}